export const JSON_INDENT_PX = 20;
export const DEFAULT_JSON_RENDER_DEPTH = 8;
export const DEFAULT_JSON_COLLECTION_ITEMS = 200;
